import { Fragment, useEffect, useRef } from "react";
import { useAuth } from "../../Context/AuthContext";
import { MyAccountHandSVG } from "../../assets/imageImport";
import { useGlobalFunction } from "../../Context/GlobalFunctionContext";
import { Link, useNavigate } from "react-router-dom";
import { MyAccountMenuList } from "./myAccountMenuList";
import { handleShowSideBar } from "../Common/common";
import { Dropdown } from "bootstrap";
import { PAGES } from "../../routeConfig";

export const MyAccountMenu = () => {
  const { userId, userName, role, isAuthenticated, companyId } = useAuth();
  const { logout } = useGlobalFunction();
  useEffect(() => {}, [isAuthenticated, userName]);
  const triggerRef = useRef(null);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  useEffect(() => {
    if (!triggerRef.current) return;

    const dropdown = new Dropdown(triggerRef.current);

    const openDropdown = () => dropdown.show();
    const closeDropdown = () => {
      setTimeout(() => {
        if (!triggerRef.current?.matches(":hover") && !dropdownRef.current?.matches(":hover")) {
          dropdown.hide();
        }
      }, 100); // little delay prevents flicker
    };

    triggerRef.current.addEventListener("mouseenter", openDropdown);
    triggerRef.current.addEventListener("mouseleave", closeDropdown);

    dropdownRef.current.addEventListener("mouseenter", openDropdown);
    dropdownRef.current.addEventListener("mouseleave", closeDropdown);

    return () => {
      triggerRef.current?.removeEventListener("mouseenter", openDropdown);
      triggerRef.current?.removeEventListener("mouseleave", closeDropdown);
      dropdownRef.current?.removeEventListener("mouseenter", openDropdown);
      dropdownRef.current?.removeEventListener("mouseleave", closeDropdown);
    };
  }, []);
  return (
    <Fragment>
      <div className="header-user d-none d-lg-inline-flex">
        <span className="wes-my-account" />
        <div className="myAccount-dropdown">
          <div
            className="header-user-info text-end text-white dropdown-toggle"
            id="headerMyAccount"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            ref={triggerRef}
            onClick={() => navigate(PAGES.MYACCOUNT)}
          >
            <div className="headerUserInfo-lft">
              <small>{userName ? "Hello " + userName : ""}</small>
              <a>My Account</a>
            </div>
            <div className="headerUserInfo-rht">
              <span className="wes-down-arrow" />
            </div>
          </div>
          <div
            className="dropdown-menu dropdown-animate-up dropdown-menu-end with-arrow"
            aria-labelledby="headerMyAccount"
            ref={dropdownRef}
          >
            <div className="dropdown-myAccount-header">
              <h5>
                Hello{" "}
                <p>
                  {userName}
                  <MyAccountHandSVG />
                </p>
              </h5>
              <div className="accInfo-header mt-1">
                <span>Company Id: </span>
                <span>{companyId}</span>
              </div>
            </div>
            <MyAccountMenuList />
            <form action={window.location.origin + "/api/Logout"} method="POST">
              <div className="dropdown-myAccount-footer">
                <button type="submit" className="signout-button">
                  Sign out
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div id="mobile-user-info" className="mobile-user-info d-block d-lg-none" onClick={handleShowSideBar}>
        <span className="wes-my-account" />
      </div>
    </Fragment>
  );
};
